export const DEFAULT_COMPARATOR = (a, b) => a === b;
const hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Makes shallow comparison of two objects.
 */
export const OBJECT_COMPARATOR = (objA, objB) => {
    if (objA === objB) {
        return true;
    }
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (let i = 0; i < keysA.length; i++) {
        const key = keysA[i];
        if (!hasOwnProperty.call(objB, key) || objA[key] !== objB[key]) {
            return false;
        }
    }
    return true;
};
export function isReadonlyArray(value) {
    return Array.isArray(value);
}
//# sourceMappingURL=utils.js.map